import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/node_modules/next/dist/client/link.js");
